import { takeLatest, call, put, select } from 'redux-saga/effects'

import I18n from 'i18n'
import createRequestCourse, {
  CreateRequestCourseParams,
  ResponseCreateRequestCourse,
} from 'api/requestCourses/CreateRequestCourse'
import admin, { ResponseRequestCourses } from 'api/requestCourses/ListAdmin'
import { ErrorToast, SuccessToast } from 'components/ui/toast/toastsTemplates'
import { getAccess } from 'contexts/AccessContext'
import {
  CREATE_REQUEST_OUTSIDE_COURSE,
  Actions,
} from '../../actions/requestOutsideCourses.action'
import { ActionWithPayload } from '../../../helpers/redux-actions.helper'
import { IMainState } from '../../states'
import { IEnrolState } from '../../states/enrol.state'

const pattern = CREATE_REQUEST_OUTSIDE_COURSE

export type CreateRequestCourseAction = ActionWithPayload<
  typeof pattern,
  {
    params: CreateRequestCourseParams
    onSuccess?(): void
    onError?(err: any): void
  }
>

function* createRequestCourseEffectSaga(action: CreateRequestCourseAction) {
  const { params, onSuccess, onError } = action.payload
  try {
    // eslint-disable-next-line
    const res: ResponseCreateRequestCourse = yield call(
      createRequestCourse,
      params
    )

    const enrols: IEnrolState = yield select(({ enrols }: IMainState) => enrols)

    try {
      if (
        getAccess().can('manageCourseRequests') ||
        enrols?.adminList?.length
      ) {
        const data: ResponseRequestCourses = yield call(admin)
        yield put(Actions.setListAdminSuccess(data))
      }
    } catch (error) {
      console.error(error)
    }

    SuccessToast(I18n.t('administration.toastMessages.createSuccess'))
    if (onSuccess) onSuccess()
  } catch (error) {
    console.error('error: ', error)
    if (onError) onError(error)
    ErrorToast(I18n.t('administration.toastMessages.createError'))
    yield put(Actions.setLoading(false))
  }
}

export function* createRequestCourseWatcherSaga() {
  yield takeLatest(pattern, createRequestCourseEffectSaga)
}
